import React, { FunctionComponent } from 'react';
import Translate from 'ui/atoms/translate';
import Currency from 'ui/atoms/currency';
import { AdminProductGlobalOverview } from 'api';
import CardItem from 'src/ui/atoms/card-item';
import BoxedContent from 'src/ui/molecules/boxed-content';

export interface ProductsOverviewProps {
  data: AdminProductGlobalOverview;
}

const ProductsOverview: FunctionComponent<ProductsOverviewProps> = (props) => {
  const { data } = props;

  return (
    <>
      <BoxedContent title={<Translate name="dashboardIssuerOverview.keyFigures" />} releaseSpaceWhenTitleIsEmpty={true}>
        <>
          <CardItem title={<Translate name="dashboardIssuerOverview.products" />} content={data.productsAmount} />
          <CardItem
            title={<Translate name="dashboardIssuerOverview.investments" />}
            content={data.numberActiveInvestments}
          />
          <CardItem
            title={<Translate name="dashboardIssuerOverview.totalAmount" />}
            content={<Currency>{data.sumActiveInvestments}</Currency>}
          />
          <CardItem
            title={<Translate name="dashboardIssuerOverview.sumPaymentsReceived" />}
            content={<Currency>{data.sumPaymentsReceived}</Currency>}
          />
        </>
      </BoxedContent>
    </>
  );
};

export default ProductsOverview;
